export default {
    en: {
        sommaire: 'Back to AccèsD home',
        title: 'Mortgage renewal',
        errorFonctionnelleText:
            'Your request cannot be processed.  Please speak to an advisor.',
        errorFonctionnelleTextConseiller:
            'The online mortgage renewal solution can no longer be viewed in read-only mode on AccèsD.',
        erreurTarifTitre: 'We’re unable to calculate your personalized offers',
        erreurTarifDescription:
            'Something went wrong. Contact your caisse to renew your mortgage with one of our experts.',
        erreurPaiementEnAttenteDateRappelImminenteTitre:
            'You’re no longer able to renew your mortgage online',
        erreurPaiementEnAttenteDateRappelEloigneeTitre:
            'You can’t renew your mortgage online today',
        erreurPaiementEnAttenteDateRappelImminenteDescription:
            'Contact us <strong>as soon as possible</strong> to renew your mortgage before your contract ends. If you don’t renew by the end of the day, your mortgage will be renewed with a 1-year open variable rate.',
        erreurPaiementEnAttenteDateRappelEloigneeDescription:
            'Come back on <strong>{{jour}}</strong> to renew your mortgage online. You can also contact us to renew it now.',
        dimanche: 'Sunday',
        mardi: 'Tuesday'
    },
    fr: {
        sommaire: 'Retour à l’accueil',
        title: 'Renouvellement hypothécaire',
        errorFonctionnelleText:
            'Il est impossible de traiter votre demande. Veuillez parler avec un conseiller.',
        errorFonctionnelleTextConseiller:
            'Le parcours de renouvellement hypothécaire numérique n’est plus présenté dans AccèsD en mode lecture.',
        erreurTarifTitre:
            'Nous n’arrivons pas à calculer vos offres sur mesure',
        erreurTarifDescription:
            "Une erreur s'est produite. Obtenez un accompagnement personnalisé en renouvelant votre prêt en caisse.",
        erreurPaiementEnAttenteDateRappelImminenteTitre:
            'Vous ne pouvez plus renouveler votre prêt en ligne',
        erreurPaiementEnAttenteDateRappelEloigneeTitre:
            'Vous ne pouvez pas renouveler votre prêt en ligne aujourd’hui',
        erreurPaiementEnAttenteDateRappelImminenteDescription:
            'Contactez-nous <strong>dès que possible</strong> pour renouveler votre prêt avant la fin de votre contrat. Sinon, il sera renouvelé avec un terme de 1\xa0an ouvert à taux variable.',
        erreurPaiementEnAttenteDateRappelEloigneeDescription:
            'Revenez dès <strong>{{jour}}</strong> pour renouveler votre prêt hypothécaire en ligne. Vous pouvez aussi nous contacter pour le faire maintenant.',
        dimanche: 'dimanche',
        mardi: 'mardi'
    }
};
